import { simpleSet } from '@r/reducers/utils';

const searchCalculationModeCabinetByName = simpleSet as
  redux.reducers.calculationMode.searching.cabinetName;

export const cabinetName = searchCalculationModeCabinetByName(
  'SEARCH_CALCULATION_MODE_CABINET_BY_NAME',
  ''
);
